import React from 'react';

import mnisw from '../../images/cmk2020-mnisw-logo-mono.png';
import ujk from '../../images/cmk2020-ujk-logo.png';
import kmujk from '../../images/cmk2020-km-ujk-logo.png';
import sciendo from '../../images/cmk2020-sciendo-logo.png';

import classes from './Footer.module.scss';

const Footer = () => {
    return <div className={classes.Footer}>
        <div className={classes.Support}>Conference supported by the Excellent Science program of the Minister of Science and Higher Education, grant No. DNK/SP/465255/2020.</div>
        <div className={classes.Images}>
            <div className={classes.Image}><img src={mnisw} alt="" /> </div>
            <div className={classes.Image}><img src={ujk} alt="" /> </div>
            <div className={classes.Image}><img src={kmujk} alt="" /> </div>
            <div className={classes.Image}><img src={sciendo} alt="" /> </div>
        </div>
    </div>
}

export default Footer;